import Banner from "../components/Banner";
import ExpertiseOurDevlopers from "../components/Expertise-Our-Developers";
import HomeBlog from "../components/Home-Our-Blog";
import HomeOurProcess from "../components/Home-Our-Process";
import HomeWhychoose from "../components/Home-Why-ChooseUs";
import OurTestimonial from "../components/Our-Testimonial";
import WorkEnquiry from "../components/Work-Enquiry";

const Home = () => {
    return (
        <>
            <Banner />
            <HomeOurProcess />
            <ExpertiseOurDevlopers />
            <HomeWhychoose />
            {/* <OurTestimonial /> */}
            {/* <HomeBlog /> */}
            <WorkEnquiry />
        </>
    )
}

export default Home